var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReorderButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "52px",
    height: "52px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    opacity: 0.2,
    fill: "rgb(255, 255, 255)",
    d: "M25.954,0.914 C40.16,0.914 51.416,12.316 51.416,26.382 C51.416,40.447 40.16,51.849 25.954,51.849 C11.891,51.849 0.491,40.447 0.491,26.382 C0.491,12.316 11.891,0.914 25.954,0.914 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(255, 237, 0)",
    d: "M33.660,20.970 C33.231,21.397 32.535,21.397 32.105,20.970 L25.596,14.501 L19.493,20.566 C19.71,20.986 18.386,20.986 17.963,20.566 C17.540,20.146 17.540,19.465 17.963,19.45 L24.933,12.117 C25.356,11.697 26.41,11.697 26.464,12.117 C26.581,12.233 26.658,12.371 26.710,12.516 L33.660,19.424 C34.90,19.852 34.90,20.544 33.660,20.970 ZM19.294,32.477 L25.862,39.47 L32.20,32.887 C32.446,32.461 33.138,32.461 33.565,32.887 C33.991,33.314 33.991,34.6 33.565,34.432 L26.531,41.468 C26.105,41.895 25.413,41.895 24.987,41.468 C24.869,41.350 24.791,41.211 24.738,41.63 L17.725,34.47 C17.291,33.613 17.291,32.910 17.725,32.477 C18.158,32.43 18.861,32.43 19.294,32.477 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorderButton);
export default __webpack_public_path__ + "static/media/reorderButton.e3da7b27.svg";
export { ForwardRef as ReactComponent };